import { usePostApi, type WriteApiOptions } from "@shared/api/hooks";
import { AUTH_RESET_PASSWORD_SERVICE_NAME } from "../constants";
import type { ResetPassword } from "../types";

export type UseResetPasswordApiOptions = Omit<
  WriteApiOptions<null, ResetPassword>,
  "serviceName" | "idRequired"
>;

/**
 * Step 3 of the reset flow — `POST /v1/{actor}/reset-password`.
 *
 * The OTP alone identifies the user, so there is no `email` field. Resolves no
 * payload; the envelope's localized message is the user feedback.
 */
export function useResetPasswordApi(options?: UseResetPasswordApiOptions) {
  return usePostApi<null, ResetPassword>({
    serviceName: AUTH_RESET_PASSWORD_SERVICE_NAME,
    invalidateKeys: false,
    ...options,
  });
}
